import { createContext } from "react";

const graphContext = createContext();

export default graphContext;
